var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.56 16.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .b {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,.21v15.75c0,.12.09.21.21.21h19.14c.12,0,.21-.09.21-.21V.21c0-.12-.09-.21-.21-.21H.21c-.12,0-.21.09-.21.21ZM1.63,1.41h2.16c.16,0,.27.18.18.32l-2.16,3.64c-.11.19-.39.11-.39-.11V1.62c0-.12.09-.21.21-.21ZM1.42,14.54v-3.63c0-.22.28-.29.39-.11l2.16,3.63c.08.14-.02.32-.18.32H1.63c-.12,0-.21-.09-.21-.21ZM5.74,14.65l-3.82-6.46c-.04-.07-.04-.15,0-.22L5.74,1.51c.04-.06.11-.1.18-.1h7.72c.07,0,.14.04.18.1l3.82,6.46c.04.07.04.15,0,.22l-3.82,6.46c-.04.06-.11.1-.18.1h-7.72c-.07,0-.14-.04-.18-.1ZM17.93,14.75h-2.16c-.16,0-.27-.18-.18-.32l2.16-3.63c.11-.18.39-.11.39.11v3.63c0,.12-.09.21-.21.21ZM17.75,5.37l-2.16-3.64c-.08-.14.02-.32.18-.32h2.16c.12,0,.21.09.21.21v3.64c0,.22-.28.29-.39.11Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M11.67,8.08c0,1.05-.85,1.89-1.89,1.89s-1.89-.84-1.89-1.89.85-1.89,1.89-1.89,1.89.85,1.89,1.89Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVor);
export default __webpack_public_path__ + "static/media/vor.e4ece808b80f82143f8e126cc8b791a2.svg";
export { ForwardRef as ReactComponent };